(() => {
  const root = document.documentElement;
  if (!('IntersectionObserver' in window) || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  root.classList.add('rr-motion-ready');
  const items = document.querySelectorAll('[data-rr-reveal]');
  if (!items.length) return;
  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (!entry.isIntersecting) return;
      entry.target.classList.add('rr-is-visible');
      observer.unobserve(entry.target);
    });
  }, { threshold: 0.08, rootMargin: '0px 0px -6% 0px' });
  items.forEach((item) => observer.observe(item));
})();

/* ROOMROOT mobile-fit kernel v2: viewport containment + native preset rail */
(() => {
  const styleId = 'rr-atmosphere-mobile-fit-v2';
  if (document.getElementById(styleId)) return;

  const style = document.createElement('style');
  style.id = styleId;
  style.textContent = `
    @media (max-width: 749px) {
      html, body {
        max-width: 100% !important;
        overflow-x: hidden !important;
      }

      .section-roomroot-atmosphere,
      .rr-atmosphere,
      .rr-atmosphere__content,
      .rr-atmosphere__modebar,
      .rr-atmosphere__copy,
      .rr-atmosphere__actions,
      .rr-atmosphere__signals {
        box-sizing: border-box !important;
        min-width: 0 !important;
        max-width: 100% !important;
      }

      .rr-atmosphere,
      .section-roomroot-atmosphere {
        width: 100% !important;
        max-width: 100vw !important;
      }

      .rr-atmosphere *,
      .rr-atmosphere *::before,
      .rr-atmosphere *::after {
        box-sizing: border-box !important;
      }

      .rr-atmosphere__content {
        width: 100% !important;
        margin-inline: auto !important;
        padding-left: max(1rem, env(safe-area-inset-left)) !important;
        padding-right: max(1rem, env(safe-area-inset-right)) !important;
      }

      .rr-atmosphere__modebar {
        display: block !important;
        width: 100% !important;
      }

      .rr-atmosphere__modes {
        display: flex !important;
        flex-wrap: nowrap !important;
        width: 100% !important;
        min-width: 0 !important;
        max-width: 100% !important;
        margin: 0 !important;
        padding: .25rem 3.75rem .8rem 0 !important;
        gap: .55rem !important;
        overflow-x: auto !important;
        overflow-y: hidden !important;
        -webkit-overflow-scrolling: touch !important;
        overscroll-behavior-x: contain;
        touch-action: pan-x !important;
        scroll-snap-type: x proximity;
        scroll-padding-left: 0;
        scroll-padding-right: 3.75rem;
        scrollbar-width: none !important;
      }

      .rr-atmosphere__modes::-webkit-scrollbar {
        display: none !important;
        width: 0 !important;
        height: 0 !important;
      }

      .rr-atmosphere__modes > .rr-atmosphere__mode {
        flex: 0 0 auto !important;
        width: auto !important;
        max-width: calc(100vw - 2rem) !important;
        white-space: nowrap !important;
        scroll-snap-align: start;
      }

      .rr-atmosphere__modes::after {
        content: '';
        display: block;
        flex: 0 0 2.75rem;
        width: 2.75rem;
        height: 1px;
        pointer-events: none;
      }

      .rr-atmosphere__status {
        display: inline-flex !important;
        max-width: 100% !important;
        margin-top: .7rem !important;
        white-space: normal !important;
      }

      .rr-atmosphere__title {
        max-width: 8.5ch !important;
        font-size: calc(clamp(3.35rem, 15.8vw, 5.6rem) * var(--rr-title-scale)) !important;
      }

      .rr-atmosphere__copy {
        width: 100% !important;
        max-width: 100% !important;
        overflow-wrap: anywhere !important;
        word-break: normal !important;
      }

      .rr-atmosphere__actions {
        display: grid !important;
        width: 100% !important;
      }

      .rr-atmosphere__button {
        width: 100% !important;
        max-width: 100% !important;
      }

      .rr-atmosphere__signals {
        display: grid !important;
        grid-template-columns: 1fr !important;
        width: 100% !important;
        gap: .3rem !important;
      }

      .rr-atmosphere__signals span {
        display: block !important;
        width: 100% !important;
        min-width: 0 !important;
        white-space: normal !important;
        overflow-wrap: anywhere !important;
      }

      .rr-atmosphere img,
      .rr-atmosphere video,
      .rr-atmosphere svg {
        max-width: 100% !important;
      }
    }
  `;
  document.head.appendChild(style);

  function centerModeButton(button, behavior) {
    if (!button || !window.matchMedia('(max-width: 749px)').matches) return;
    const rail = button.closest('.rr-atmosphere__modes');
    if (!rail || rail.scrollWidth <= rail.clientWidth) return;

    const railRect = rail.getBoundingClientRect();
    const buttonRect = button.getBoundingClientRect();
    const desired = rail.scrollLeft + (buttonRect.left - railRect.left) - ((railRect.width - buttonRect.width) / 2);
    const max = Math.max(0, rail.scrollWidth - rail.clientWidth);
    const left = Math.max(0, Math.min(desired, max));

    try {
      rail.scrollTo({ left, behavior: behavior || 'auto' });
    } catch (error) {
      rail.scrollLeft = left;
    }
  }

  function centerCurrentMode(behavior) {
    document.querySelectorAll('.rr-atmosphere__modes').forEach((rail) => {
      const active = rail.querySelector('.rr-atmosphere__mode.is-active, .rr-atmosphere__mode[aria-pressed="true"]');
      if (active) centerModeButton(active, behavior || 'auto');
    });
  }

  document.addEventListener('click', (event) => {
    const button = event.target.closest ? event.target.closest('.rr-atmosphere__mode[data-roomroot-mode]') : null;
    if (!button) return;
    window.requestAnimationFrame(() => centerModeButton(button, 'smooth'));
  });

  const init = () => window.requestAnimationFrame(() => centerCurrentMode('auto'));
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();

  window.addEventListener('orientationchange', () => {
    window.setTimeout(() => centerCurrentMode('auto'), 180);
  });
})();
